import { render, staticRenderFns } from "./NotificationsActions.vue?vue&type=template&id=bc7f1124&"
import script from "./NotificationsActions.vue?vue&type=script&lang=js&"
export * from "./NotificationsActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports